import axios from "axios";

const TIMEOUT = 15000;

const tanValidation = async (tan: string, transactionId: string) => {
  const tanValidationUrl = `${process.env.REACT_APP_TAN_SERVICE}/validate/${transactionId}`;
  return axios.post(
    tanValidationUrl,
    {
      tan
    },
    {
      validateStatus: (status) => status === 200,
      timeout: TIMEOUT,
    }
  );
};

const resendTan = async (transactionId: string) => {
  const resendTanUrl = `${process.env.REACT_APP_TAN_SERVICE}/resend/${transactionId}`;
  return axios.post(
    resendTanUrl,
    {},
    {
      validateStatus: (status) => status === 200,
      timeout: TIMEOUT,
    }
  );
};

const sendTan = async (transactionId: string) => {
  const sendTanUrl = `${process.env.REACT_APP_TAN_SERVICE}/send/${transactionId}`;
  return axios.post(
    sendTanUrl,
    {},
    {
      validateStatus: (status) => status === 200,
      timeout: TIMEOUT,
    }
  );
};

export { tanValidation, resendTan, sendTan };
